import React from 'react';

import './Progressbar.scss';

export const DefaultOptions = {
  Rtl: false,
  BackgroundColor: '#DDDDDD',
  ProgressColor: '#3F80EA',
  Height: '4px',
  Dynamic: false,
  DynamicColors: {
    Success: '#27AE60',
    Warning: '#F39C12',
    Danger: '#E74C3C'
  },
  DynamicMin: {
    Warning: 60,
    Danger: 80
  }
}

const Progressbar = ({
  progressColor = undefined,
  backColor = undefined,
  value = 0,
  rtl = undefined,
  height = undefined,
  dynamic = false,
  dynamicWarningMin = undefined,
  dynamicDangerMin = undefined,
  dynamicColorSuccess = undefined,
  dynamicColorWarning = undefined,
  dynamicColorDanger = undefined,
}) => {

  if (rtl == null) {
    rtl = DefaultOptions.Rtl;
  }

  const direction = rtl ? 'rtl' : 'ltr';

  if (typeof value !== 'number') {
    throw new Error('Progressbar => value must be a number');
  }

  const backStyle: any = {
    height,
    direction,
    backgroundColor: (backColor ?? DefaultOptions.BackgroundColor)
  };

  const progressStyle: any = {
    width: value + '%',
    direction,
    backgroundColor: (progressColor ?? DefaultOptions.ProgressColor)
  };

  if (dynamic) {
    let color: string;
    if (value < (dynamicWarningMin ?? DefaultOptions.DynamicMin.Warning)) {
      color = dynamicColorSuccess ?? DefaultOptions.DynamicColors.Success;
    }
    else if (value < (dynamicDangerMin ?? DefaultOptions.DynamicMin.Danger)) {
      color = dynamicColorWarning ?? DefaultOptions.DynamicColors.Warning;
    }
    else {
      color = (dynamicColorDanger ?? DefaultOptions.DynamicColors.Danger);
    }
    progressStyle.backgroundColor = color;
  }

  return (
    <div className="cmp-progressbar">
      <div className="bar-back" style={backStyle}>
        <div className="bar-progress" style={progressStyle}></div>
      </div>
    </div>
  );
};

export default Progressbar;
